// Backend endpoints. Overridable via Vite env so the app can run against a
// local/containerized stack (see agent-container); defaults = production.
const BACKEND_SERVER_URL =
  import.meta.env.VITE_TESTER_URL || "https://tester-eu.mobileboost.io";

const FASTAPI_SERVER_URL =
  import.meta.env.VITE_API_BASE_URL || "https://api.mobileboost.io";
const APPIUM_MIDDLEWARE_URL = `${FASTAPI_SERVER_URL}/appium-middleware`;

const LAMBDA_AWS_URL = `${FASTAPI_SERVER_URL}/call_lambda`;
const LAMBDA_AWS_TIMEOUT = 60000;

export {
  LAMBDA_AWS_URL,
  LAMBDA_AWS_TIMEOUT,
  BACKEND_SERVER_URL,
  FASTAPI_SERVER_URL,
  APPIUM_MIDDLEWARE_URL,
};
